import { useTranslation } from 'react-i18next'
import { StatusBadge, type StatusBadgeIndicator, type StatusBadgeTone } from '@/shared/ui/StatusBadge'

/** Состояние канала для пользователя: на связи, идёт переподключение, сети нет. */
export type ConnectionState = 'online' | 'reconnecting' | 'offline'

const TONE: Record<ConnectionState, StatusBadgeTone> = {
  online: 'success',
  reconnecting: 'warning',
  offline: 'danger',
}

/** Пульс — живой канал, спиннер — идёт переподключение, точка — связи нет. */
const INDICATOR: Record<ConnectionState, StatusBadgeIndicator> = {
  online: 'pulse',
  reconnecting: 'spinner',
  offline: 'dot',
}

/**
 * Индикатор связи в шапке — только представление: состояние вычисляет контейнер. Тон, маркер
 * и подпись — из токенов `StatusBadge`, тёмная тема и 360px работают без правок компонента.
 */
export function ConnectionStatus({ state }: { state: ConnectionState }) {
  const { t } = useTranslation()

  return (
    <StatusBadge
      tone={TONE[state]}
      size="md"
      indicator={INDICATOR[state]}
      label={`${t('connection.label')}: ${t(`connection.${state}`)}`}
    >
      {t(`connection.${state}`)}
    </StatusBadge>
  )
}
